/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliveryOrderCreateRequestSchema } from "./deliveryOrderCreateRequestSchema.ts";
import { deliveryOrderSchema } from "./deliveryOrderSchema.ts";
import { errorResponseSchema } from "./errorResponseSchema.ts";

export const orgUnitDeliveryOrderCreateCreatePathOrgUnitIdSchema = z.uuid();

export const orgUnitDeliveryOrderCreateCreateStatus201Schema = deliveryOrderSchema;

export const orgUnitDeliveryOrderCreateCreateStatus400Schema = errorResponseSchema;

export const orgUnitDeliveryOrderCreateCreateResponseSchema = z.union([
	orgUnitDeliveryOrderCreateCreateStatus201Schema,
	orgUnitDeliveryOrderCreateCreateStatus400Schema,
]);

export const orgUnitDeliveryOrderCreateCreateDataSchemaJson = deliveryOrderCreateRequestSchema;

export const orgUnitDeliveryOrderCreateCreateDataSchemaXml = deliveryOrderCreateRequestSchema;

export const orgUnitDeliveryOrderCreateCreateDataSchema = z.union([
	orgUnitDeliveryOrderCreateCreateDataSchemaJson,
	orgUnitDeliveryOrderCreateCreateDataSchemaXml,
]);
